<template lang="pug">
    .drawer-container
        el-button(
            type="info"
            icon="el-icon-fa-undo fas"
            size="large"
            @click="openTakeBackDrawer"
        ) {{ $t('Take Back Item') }}
        el-drawer.take-back-drawer(
            :title="$t('Take Back Item')"
            :visible.sync="drawer.visibility"
            :modal="true"
            size="50%"
            @close="$emit('focus-search')"
            @closed="resetTakeBackDrawer"
        )
            .drawer-body(v-loading="drawer.loading")
                el-form(
                    ref="form"
                    label-position="top"
                    :model="drawer.form"
                    :rules="drawer.rules"
                    @submit.prevent.stop="findPurchase"
                    @submit.native.prevent.stop
                )
                    .flex-row
                        el-form-item.grow(:label="$t('Receipt barcode')" prop="input")
                            el-input(
                                ref="uid"
                                v-model="drawer.form.input"
                                @keyup.enter.native="findPurchase"
                            )
                        el-form-item(label=" " prop="action")
                            //- :disabled="!drawer.form.sku"
                            el-button(
                                type="success"
                                icon="el-icon-fa-search fas"
                                @click="findPurchase"
                            ) {{ $t('List purchased items') }}
                    transition(name="slide-decent-vertical" mode="out-in")
                        .alert.primary(v-if="! drawer.form.input" key="alert")
                            p {{ $t('Scan the barcode from the receipt') }}
                        .purchase-details(v-else-if="drawer.form.purchase" key="details")
                            .flex-row
                                .general-summary
                                    .nr {{ $t('Purchase Nr.') }}: {{ drawer.form.purchase.id }}
                                    .created_at {{ $t('Date') }}: {{ drawer.form.purchase.created_at | timestamp2date(dateTimeFormat) }}
                                    .seller(v-if="drawer.form.purchase.seller") {{ $t('Sold by') }}: {{ drawer.form.purchase.seller.name }}
                                    //- .purchaser(v-if="drawer.form.purchase.purchaser") {{ $t('Sold to') }} {{ drawer.form.purchase.purchaser.name }}
                                .price-summary
                                    table
                                        tr.price-row(v-for="row in drawer.form.purchase.detailedSummary")
                                            td
                                                nobr(v-if="couponPercentage && row.key.startsWith('discount-percentage')")
                                                    | {{ $t('{percentage}% Discount', { percentage: couponPercentage }) }}
                                                nobr(v-else) {{ $t(row.key) }}
                                            td.col-right
                                                nobr(v-if="row.key.startsWith('discount')") -{{ row.amount | moneyFormat(drawer.form.purchase.currency) }}
                                                nobr(v-else) {{ row.amount | moneyFormat(drawer.form.purchase.currency) }}
                                        //- tr.price_row(v-if="drawer.form.purchase.tax_total")
                                        //-     td
                                        //-         nobr {{ $t('VAT included') }}
                                        //-     td.col-right
                                        //-         nobr {{ drawer.form.purchase.tax_total | moneyFormat(drawer.form.purchase.currency) }}
                                        tr.price-row
                                            td
                                                nobr {{ $t('Grand total') }}
                                            td.col-right
                                                nobr
                                                    b {{ drawer.form.purchase.grand_total | moneyFormat(drawer.form.purchase.currency) }}
                            .items-list
                                //- h4 {{ $t('Purchased items')}}
                                table.default-table
                                    thead
                                        tr
                                            th.min.checkbox
                                                transition(name="fade")
                                                    i.el-icon-fa-arrow-down.fas(v-if="nothingSelected")
                                            //- th.min.media
                                            th.col-left.item {{ $t('Item') }}
                                            th.col-left {{ $t('Properties') }}
                                            th.dimmed.col-right {{ $t('Price') }}
                                            th.col-center {{ $t('Quantity') }}
                                            th.col-right {{ $t('Total') }}
                                    tbody
                                        tr.spacer
                                            td(colspan="5")
                                        tr.item(v-for="item in drawer.form.purchase.items")
                                            td.min.checkbox
                                                el-checkbox(:value="item.selected" @change="checked => toggleItem(item, checked)")
                                            //- td.min.media
                                            //-     //- NOTE: neeeds article/product instance
                                            //-     item-media-preview(:item="item")
                                            td.col-left.item
                                                .name(v-line-clamp="1")
                                                    b {{ item.name }}
                                                small {{ item.product_nr }}
                                                span &nbsp;/&nbsp;
                                                small {{ item.sku }}
                                            td.col-left
                                                .properties
                                                    property-value(
                                                        v-for="property in item.selectedProperties"
                                                        :key="property.id"
                                                        :property="property"
                                                    )
                                            td.min.dimmed.col-right
                                                .sale-price(v-if="item.sale_price && item.sale_price < item.price")
                                                    .nobr
                                                        s.strike-through.dimmed {{ item.price | moneyFormat(drawer.form.purchase.currency) }}
                                                        //- span.percentage {{ (item.price - item.sale_price) / item.price * 100 | round(2) }}%
                                                    nobr.red.dimmed {{ item.sale_price | moneyFormat(drawer.form.purchase.currency) }}
                                                nobr.dimmed(v-else) {{ item.price | moneyFormat(drawer.form.purchase.currency) }}
                                            td.min.col-center
                                                template(v-if="item.selected === true")
                                                    el-input-number.qty(
                                                        :value="item.take_back_qty"
                                                        size="small"
                                                        :min="1"
                                                        :max="item.qty"
                                                        :step-strictly="true"
                                                        @change="qty => updateItemTakeBackQty(item, qty)"
                                                    )
                                                template(v-else)
                                                    el-input-number.qty(
                                                        :value="item.qty"
                                                        size="small"
                                                        disabled
                                                    )
                                            td.col-right.min
                                                template(v-if="item.selected && item.take_back_qty")
                                                    .amount-input-sizer
                                                        .occupy-space
                                                            nobr {{ getFormattedItemCreditedAmount(item) }}
                                                        money.el-input__inner(
                                                            v-model="item.take_back_credited_amount"
                                                            v-bind="getMoneyConfig(drawer.form.purchase.currency)"
                                                            @input="updateCouponAmount"
                                                        )
                                                template(v-else)
                                                    .sale-price(v-if="item.sale_price && item.sale_price < item.price")
                                                        .nobr
                                                            small.percentage {{ (item.price - item.sale_price) / item.price * 100 | round(2) }}%
                                                        b.nobr.red {{ item.sale_price * item.qty | moneyFormat(drawer.form.purchase.currency) }}
                                                    b.nobr(v-else) {{ item.price * item.qty | moneyFormat(drawer.form.purchase.currency) }}
                                        tr.spacer
                                            td(colspan="5")
                                transition(name="slide-decent-vertical")
                                    .alert.warning(v-if="nothingSelected")
                                        p {{ $t('Select items you want to take back') }}
            transition(name="fade")
                .drawer-footer(v-if="nothingSelected === false")
                    .form-row(style="width: 100%")
                        el-form(
                            ref="bottom-form"
                            label-position="top"
                            :model="drawer.form"
                            :rules="drawer.rules"
                            @submit.prevent.stop="findPurchase"
                            @submit.native.prevent.stop
                        )
                            .flex-row
                                el-form-item.no-margin.grow(:label="$t('Stock')" prop="stock")
                                    el-select.is-full-width(
                                        v-model="drawer.form.stock"
                                        :disabled="stockOptions.length <= 1 || drawer.saving || drawer.loading"
                                        placeholder=""
                                        valueKey="id"
                                    )
                                        el-option(
                                            v-for="stock in stockOptions"
                                            :key="stock.id"
                                            :label="stock.name"
                                            :value="stock"
                                        )
                                el-form-item.no-margin(:label="$t('Coupon amount')")
                                    el-input(
                                        :value="formattedCouponAmount"
                                        disabled
                                    )
                    .actions-row
                        el-button(
                            round
                            icon="el-icon-fa-times fas"
                            @click="closeTakeBackDrawer"
                        ) {{ $t('Dismiss') }}
                        el-button(
                            round
                            :disabled="drawer.loading"
                            :loading="drawer.saving"
                            type="primary"
                            icon="el-icon-fa-check fas"
                            @click="takeBack"
                        ) {{ $t('Take back selected items and create a coupon') }}
</template>

<i18n>
{
    "en": {
        "{percentage}% Discount": "{percentage}% Discount",
        "sub-total": "Sub total",
        "sub-total-net": "Sub total (net)",
        "discount-total": "Discount",
        "discount-total-net": "Discount (net)",
        "discount-percentage": "Discount percentage",
        "discount-percentage-net": "Discount percentage (net)",
        "credited-amount-total": "Credited amount",
        "shipping-fee": "Shipping fee",
        "shipping-fee-net": "Shipping fee (net)",
        "tax-sum": "Tax sum"
    },
    "de": {
        "Take Back Item": "Artikel zurücknehmen",
        "Scan the barcode from the receipt": "Scanne den Barcode von der Quittung",
        "Receipt barcode": "Quittung Barcode",
        "List purchased items": "Verkaufte Artikel auflisten",
        "Purchase not found": "Verkauf konnte nicht gefunden werden",
        "Select items you want to take back": "Wähle die Artikel, die du zurücknehmen möchtest",
        "Take back selected items and create a coupon": "Artikel zurücknehmen und einen Gutschein erstellen",
        "You need to selet a stock": "Wähle ein Lagerort aus",
        "Stock could not be updated,": "Bestand konnte nicht aktualisiert werden.",
        "Coupon could not be created.": "Gutschein konnte nicht erstellt werden",
        "Coupon has been created successfully!": "Gutschein wurde erfolgreich erstellt!",
        "Could not print the coupon!": "Gutschein konnte nicht gedruckt werden!",

        "Purchase Nr.": "Auftragsnummer",
        "Date": "Datum",
        "Sold by": "Verkauft durch",
        "Sold to": "Verkauft an",
        "Purchased items": "Verkaufte Artikel",
        "Take back": "Zurücknehmen",
        "Item": "Artikel",
        "Properties": "Attribute",
        "Price": "Preis",
        "Quantity": "Menge",
        "Total": "Gesamt",
        "Stock": "Lagerort",
        "Coupon amount": "Gutschein-Wert",

        "VAT included": "Enthaltene MwSt.",
        "Net": "Netto",
        "Sub total": "Zwischensumme",
        "Grand total": "Gesamtbetrag",
        "Order": "Bestellung",
        "Ordered at": "Bestellt am",
        "Payment method": "Zahlungsart",
        "Shipping method": "Versandart",
        "Shipping fee": "Versandkosten",
        "Discount": "Rabatt",
        "{percentage}% Discount": "{percentage}% Rabatt",

        "sub-total": "Zwischensumme",
        "sub-total-net": "Netto",
        "discount-total": "Rabatt",
        "discount-total-net": "Rabatt",
        "discount-percentage": "Rabatt",
        "discount-percentage-net": "Rabatt",
        "credited-amount-total": "Gutschrift",
        "shipping-fee": "Versandkosten",
        "shipping-fee-net": "Versandkosten",
        "tax-sum": "MwSt."
    }
}
</i18n>

<script>
import uniqid from 'uniqid'
import printJS from 'print-js-updated';
import { moneyFormat, currencySymbol, timestamp2date } from '@/filters'

import PurchaseApi from '@/extensions/shop/store/api/purchase';
import CouponApi from '@/extensions/shop/pointOfSale/store/api/coupon'
import StockApi from '@/extensions/shop/pointOfSale/store/api/stock';
import AuthApi from '@/store/api/system/auth';
import { useAuthStore, useSetupStore, usePosSetupStore, usePosCartStore } from '@/stores'

import { Money } from 'v-money'
import PropertyValue from '@/extensions/shop/views/Purchase/Form/Partials/PropertyValue'
import ItemMediaPreview from './ItemMediaPreview'

export default {
    name: 'TakeBackDrawer',
    data() {
        return {
            drawer: {
                visibility: false,
                loading: false,
                saving: false,
                tab: undefined,
                form: {
                    input: '',
                    stock: undefined,
                    coupon: undefined,
                    purchase: undefined,
                },
                rules: {
                    input: 'required',
                    stock: 'required',
                },
            },
        };
    },
    components: {
        PropertyValue,
        ItemMediaPreview,
        Money
    },
    filters: {
        moneyFormat,
        timestamp2date
    },
    computed: {
        posSetupStore() {
            return usePosSetupStore();
        },
        posCartStore() {
            return usePosCartStore();
        },
        nothingSelected() {
            let nothing = true
            if (this.drawer.form.purchase && this.drawer.form.purchase.items.length) {
                nothing = this.drawer.form.purchase.items.filter(el => el.selected === true).length === 0
            }
            return nothing
        },
        dateTimeFormat() {
            const template = this.$t('yyyy-MM-dd')
            return `${template}, HH:mm`
        },
        couponPercentage() {
            let percentage;
            const coupons = this.drawer.form.purchase.coupons;
            if (coupons && coupons.length === 1 && coupons[0]['type'] === 'percentage') percentage = coupons[0]['percentage'];
            return percentage;
        },
        stockOptions() {
            return this.activePointOfSale.stocks || []
        },
        user() {
            return useAuthStore().user;
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale;
        },
        purchaser() {
            return this.posCartStore.purchaser;
        },
        options() {
            return this.posSetupStore.options;
        },
        formattedCouponAmount() {
            const amount = (this.drawer.form.coupon && this.drawer.form.coupon.amount) || 0
            const currency = (this.drawer.form.purchase && this.drawer.form.purchase.currency) || 'EUR'
            return moneyFormat(amount, currency)
        },
    },
    methods: {
        getMoneyConfig(currency) {
            let moneyConfig = {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: ' ' + currencySymbol(currency),
                precision: 2,
                masked: false
            }
            switch (currency) {
                case 'USD':
                    moneyConfig.decimal = '.';
                    moneyConfig.thousands = ',';
                    moneyConfig.suffix = '';
                    moneyConfig.prefix = currencySymbol(currency) + ' ';
                    break;
            }
            return moneyConfig
        },
        openTakeBackDrawer() {
            // this.drawer.loading = true;
            this.drawer.visibility = true;

            const stock = this.stockOptions[0]
            this.drawer.form.stock = stock

            this.drawer.form.coupon = {
                id: uniqid('new:'),
                name: undefined,
                description: undefined,
                code: uniqid(`POS-${this.activePointOfSale.id}-`).toUpperCase(),
                position: undefined,
                type: 'fixed',
                max_uses: 1,
                max_uses_per_customer: undefined,
                percentage: undefined,
                amount: undefined,
                start_at: undefined,
                end_at: undefined,
                // pivot: { uses: 0 },
                discard_the_following_coupons: false,
                discard_remaining_amount: false,
                shop: this.activeCms.shop
            }

            let customer = this.purchaser ? this.purchaser.customer : null
            if (! customer && this.activePointOfSale.customerGroup) {
                customer = {
                    id: null,
                    customerGroup: this.activePointOfSale.customerGroup
                }
            }

            const customerGroup = _.get(customer, 'customerGroup')
            const defaultCustomerGroup = _.get(this.activeCms, 'shop.defaultCustomerGroup');
            if (customerGroup && customerGroup.id !== defaultCustomerGroup.id) {
                this.drawer.form.coupon.applicable_for = 'customer-group'
                this.drawer.form.coupon.customerGroups = [ customerGroup ]
                this.drawer.form.coupon.currency = customerGroup.currency
            }

            // 12648#637ded2762f31
            this.$emit('blur-search');
            this.updateAutofocusSearchInput(false);

            this.$nextTick(() => {
                this.$refs.uid.focus();
            });

            // let actions = []
            // const initializeCashReports = CashReportApi.initializeCashReports(this.activePointOfSale.id)
            //     .then(cashReports => {
            //         this.drawer.form.cashReports = cashReports
            //         if (cashReports.length) {
            //             cashReports.forEach((el, i) => {
            //                 this.$set(this.drawer.rules.cashReports, i, {
            //                     is: 'required|min_value:0.00',
            //                     take: 'min_value:0.00|max_value:0.00',
            //                     keep: 'min_value:0.00|max_value:0.00',
            //                 })
            //             })
            //         }
            //     }).catch(err => {
            //         this.$notify.error({
            //             title: this.$t('An error occurred!'),
            //             iconClass: 'fas el-icon-fa-times',
            //             position: 'bottom-left',
            //             customClass: 'dark',
            //             duration: 8000
            //         });

            //         console.error(err)
            //     })
            // actions.push(initializeCashReports)

            // Promise.all(actions)
            //     .catch(error => {
            //         console.error(error)
            //         this.$notify.error({
            //             title: this.$t('Logs could not be fetched'),
            //             iconClass: 'fas el-icon-fa-times',
            //             position: 'bottom-left',
            //             customClass: 'dark',
            //             duration: 8000
            //         });
            //     })
            //     .finally(() => {
            //         const cashFlowLogs = this.drawer.paginatedCashFlowLogs.filter(el => el.pagination)
            //         if (this.drawer.tab === undefined && cashFlowLogs.length) {
            //             this.drawer.tab = cashFlowLogs[0].paymentMethod.service
            //         }

            //         this.drawer.loading = false;
            //         if (this.drawer.tab === undefined) {
            //             this.drawer.tab = 'cash-report'
            //         } else {
            //             const cashFlowLogs = this.drawer.paginatedCashFlowLogs.find(el => {
            //                 return el.paymentMethod.service === this.drawer.tab
            //             })
            //             this.$nextTick(() => {
            //                 this.loadMoreCashFlowLogsIfNeeded(this.$refs[`cash-flow-logs-${this.drawer.tab}`], cashFlowLogs)
            //             })
            //         }
            //     })
        },
        findPurchase() {
            this.$refs.form.validate(async (valid, errors) => {
                if (valid) {
                    const parts = this.drawer.form.input.split('#')
                    if (parts.length !== 2) {
                        this.$notify.warning({
                            title: this.$t('The receipt barcode is invalid!'),
                            iconClass: 'fas el-icon-fa-exclamation-circle',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                        return false;
                    }

                    // 70303#7
                    const id = parts[0]
                    const pointOfSale = parts[1]

                    this.$set(this.drawer.form, 'purchase', undefined)

                    this.drawer.loading = true;
                    let purchase = await PurchaseApi.fetchPurchase({ id, pointOfSale })
                        .catch(err => {
                            const { networkError, graphQLErrors } = err;
                            const code = _.get(graphQLErrors, '0.code');

                            if (code === 404) {
                                this.$notify.error({
                                    title: this.$t('Purchase not found'),
                                    iconClass: 'fas el-icon-fa-times',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000
                                });
                            } else {
                                this.$notify.error({
                                    title: this.$t('An error occurred!'),
                                    iconClass: 'fas el-icon-fa-times',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000
                                });
                            }

                            console.error(err)
                        })

                    this.drawer.loading = false;

                    if (purchase) {
                        purchase = _.cloneDeep(purchase)
                        this.$set(this.drawer.form, 'purchase', purchase)
                        if (purchase.items.length === 1) {
                            this.toggleItem(purchase.items[0], true)
                        }
                        // this.$set(this.drawer.form.coupon, 'code', uniqid(`P${this.activePointOfSale.id}-R${purchase.id}-`).toUpperCase())
                    }
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            })
        },
        getItemUnitPrice(item) {
            const salePrice = parseFloat(item.sale_price)
            const price = parseFloat(item.price)
            return (salePrice > 0 && salePrice < price) ? salePrice : price
        },
        getFormattedItemCreditedAmount(item) {
            const amount = item.take_back_credited_amount || 0
            const currency = (this.drawer.form.purchase && this.drawer.form.purchase.currency) || 'EUR'
            return moneyFormat(amount, currency)
        },
        toggleItem(item, checked = false) {
            if (checked) {
                this.$set(item, 'selected', true)
                this.$set(item, 'take_back_qty', 1)
                this.$set(item, 'take_back_credited_amount', this.getItemUnitPrice(item) * 1)
            } else {
                this.$delete(item, 'selected')
                this.$delete(item, 'take_back_qty')
                this.$delete(item, 'take_back_credited_amount')
            }
            this.updateCouponAmount()
        },
        updateItemTakeBackQty(item, qty) {
            if (qty >= 1) {
                this.$set(item, 'take_back_qty', qty)
                this.$set(item, 'take_back_credited_amount', this.getItemUnitPrice(item) * qty)
            } else {
                this.toggleItem(item)
            }
            this.updateCouponAmount()
        },
        updateCouponAmount() {
            let amount = 0
            this.drawer.form.purchase.items.forEach(item => {
                if (! item.selected || ! item.take_back_qty) return
                amount += item.take_back_credited_amount || 0
            })
            this.$set(this.drawer.form.coupon, 'amount', amount)
        },
        async takeBack() {
            if (! this.drawer.form.stock) {
                this.$notify.warning({
                    title: this.$t('Form is not valid!'),
                    message: this.$t('You need to selet a stock'),
                    iconClass: 'fas el-icon-fa-exclamation-circle',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
                return
            }

            this.drawer.saving = true

            const selectedItems = this.drawer.form.purchase.items.filter(
                item => item.selected && item.take_back_qty
            )

            const cancellation = await PurchaseApi.cancelPurchasedItems({
                purchase: { id: this.drawer.form.purchase.id },
                items: selectedItems.map(item => ({
                    id: item.id,
                    pivot: {
                        qty: item.take_back_qty,
                        credited_amount: item.take_back_credited_amount,
                    }
                })),
                credited_amount: this.drawer.form.coupon.amount,
                stock: { id: this.drawer.form.stock.id },
            }).catch(error => {
                console.error(error)
                this.drawer.saving = false
                this.$notify.error({
                    title: this.$t('An error occurred!'),
                    message: this.$t('Items could not be returned.'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
            })

            if (cancellation) {
                    const coupon = await CouponApi.create({
                        coupon: this.drawer.form.coupon,
                        pointOfSale: this.activePointOfSale,
                        print: true,
                    })
                        .catch(error => {
                            console.error(error)
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Coupon could not be created.'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000,
                            })
                        });

                    if (coupon) {
                        this.$notify.success({
                            title: this.$t('Coupon has been created successfully!'),
                            iconClass: 'fas el-icon-fa-check',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })

                        // Build a queue of files to print sequentially.
                        // Stornobeleg first (fiscal document), coupon second.
                        const printQueue = []

                        if (cancellation.latestTillRoll) {
                            printQueue.push(cancellation.latestTillRoll)
                        }

                        if (coupon.tillRoll) {
                            printQueue.push(coupon.tillRoll)
                        }

                        if (printQueue.length) {
                            this.printFilesSequentially(printQueue, () => {
                                this.drawer.saving = false;
                                this.closeTakeBackDrawer();
                            })
                        } else {
                            this.drawer.saving = false;
                            this.closeTakeBackDrawer();
                        }
                    } else {
                        this.drawer.saving = false;
                        this.closeTakeBackDrawer();
                    }
            } else {
                this.drawer.saving = false
                this.closeTakeBackDrawer();
            }
        },

        /**
         * Print a list of files one after the other.
         * Each next print is triggered only after the current print dialog closes.
         */
        printFilesSequentially(files, onAllDone) {
            var self = this;
            var remaining = files.slice();

            function printNext() {
                if (!remaining.length) {
                    if (onAllDone) onAllDone();
                    return;
                }

                var file = remaining.shift();
                var storageRoute = _.trim(process.env.VUE_APP_API_ENDPOINT + process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE, '/');
                var token = AuthApi.getToken();
                var printable = storageRoute + '/files/' + file.id + '/' + file.name + '?token=' + token;

                printJS({
                    printable: printable,
                    onError: function() {
                        self.$notify.error({
                            title: self.$t('An error occurred!'),
                            message: self.$t('Could not print the document!'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        });
                        printNext();
                    },
                    onPrintDialogClose: function() {
                        printNext();
                    }
                });
            }

            printNext();
        },
        closeTakeBackDrawer() {
            this.drawer.visibility = false;
        },
        resetTakeBackDrawer() {
            this.drawer = {
                visibility: false,
                loading: false,
                saving: false,
                tab: undefined,
                form: {
                    input: '',
                    stock: undefined,
                    coupon: undefined,
                    purchase: undefined,
                },
                rules: {
                    input: 'required',
                    stock: 'required',
                },
            }

            setTimeout(() => {
                // this.$refs.form.resetFields()
                if (this.$refs.form) this.$refs.form.clearValidate()
            }, 0)

            this.updateAutofocusSearchInput(true);
            this.$emit('focus-search');
        },
        updateAutofocusSearchInput(value) {
            this.posSetupStore.updateAutofocusSearchInput(value);
        },
    },
};
</script>

<style lang="sass" scoped>
.take-back-drawer
    .drawer-body
        flex-grow: 1
        overflow: auto
        // padding: 0
        padding: 20px
        max-height: calc(100vh - 66px) // - 69px
        hr
            flex-grow: 1
            opacity: 0.5
            width: 100%
    .el-form
        padding-bottom: 20px
    .flex-row
        display: flex
        gap: 1rem
        .grow
            flex-grow: 1
    .scroll-box
        max-height: calc(100vh - 66px) // - 69px
        padding-right: 20px
        overflow: auto

    &::v-deep .el-loading-mask
        background-color: rgba(255, 255, 255, 0.6) !important

    .purchase-details .flex-row
        display: flex
        justify-content: space-between
    .price-summary
        table
            border-collapse: collapse
            td
                padding: 0
                & + td
                    padding-left: 10px
            tr
                td
                    &:first-child
                        text-align: right

    table.default-table
        width: 100%
        border-spacing: unset
        .dimmed
            color: $color-grey-text
        .divider hr
            opacity: 0.5

        // .name
            display: flex
            max-width: 100%
            .trim-wrap
                flex: 1 1 100%
                min-width: 0
                .trim
                    max-width: 100%
                    overflow: hidden
                    text-overflow: ellipsis
                    white-space: nowrap

        .properties
            display: flex
            gap: 4px
            ::v-deep .property-value
                padding: 4px 6px
                background: darken($color-skeleton, 10%)
                border-radius: 4px
                font-size: 0.85em
                label
                    font-size: 0.8em
                    display: block
                    &:after
                        content: ''
        .el-input-number.qty
            // width: 100px
            width: 120px
        label.el-checkbox
            &::v-deep
                .el-checkbox__input
                    .el-checkbox__inner
                        width: 24px
                        height: 24px
                        &:after
                            scale: 2
                            left: 9px
                            top: 4px
                    &:not(.is-checked)
                        .el-checkbox__inner
                            border-color: lighten($--shop-color-primary, 30%)
                &:hover,
                &:focus
                    .el-checkbox__input:not(.is-checked)
                        .el-checkbox__inner
                            border-color: $--shop-color-primary
        &::v-deep
            .el-input.is-disabled .el-input__inner
                color: inherit

        .amount-input-sizer
            position: relative
            display: inline-block
            .occupy-space
                opacity: 0
                min-height: 32px
                pointer-events: none
                nobr
                    display: block
                    padding: 0 15px
                    font-size: 1.1rem
                    white-space: nowrap
                    line-height: 32px
            input.el-input__inner
                position: absolute
                top: 0
                left: 0
                width: 100%
                height: 100%

    .drawer-footer
        flex-direction: column
        .actions-row
            width: 100%
            display: flex
            justify-content: space-between

.sale-price
    s
        display: inline-block
        font-size: 0.8em
        // font-weight: bold
        text-decoration: none
        color: rgba(0,0,0,0.6)
    .red
        color: $--color-danger
        &.dimmed
            color: lighten($--color-danger, 10%)
    .strike-through
        position: relative
        &:before
            position: absolute
            content: ""
            left: -3px
            top: 50%
            right: -3px
            border-top: 1px solid rgba(0,0,0,0.6)
            // border-color: $--color-info
            transform: rotate(-5deg)
        &.dimmed:before
            border-color: rgba(0,0,0,0.25)

.no-margin-top
    margin-top: 0
</style>
